"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const orto_1 = require("../capabilities/orto");
const topo_1 = require("../capabilities/topo");
exports.LAYERS = {
    topo: {
        label: 'Mapa topograficzna',
        def: topo_1.topo
    },
    orto: {
        label: 'Ortofotomapa',
        def: orto_1.orto
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/logic/layers.ts
// module id = 119
// module chunks = 0 1